// This is just an example,
// so you can safely delete all default props below

export default {
    content: 'Content',
    new: 'New Content',
    back: 'Back',
    name: 'Name',
    start_at: 'Start At',
    end_at: 'End At',
    delete: 'Delete',
    save: 'Save'
}
